import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './success.routes';
import api from '../../../components/api-service';
import util from '../../../components/util/util.module';

import 'angular-translate';
import feconClientBundle from '@infocert/fecon-client-bundle';
const translateModule = 'pascalprecht.translate';

export class SuccessController {

    constructor(notifier, $state, $log, iceApplicationPreferences, vcRecaptchaService, EmailService, LmrcApiService, queryParamGetter) {
        'ngInject';
        this._logger = $log.getInstance('SuccessController');
        this.notifier = notifier;
        this._$state = $state;
        this._lmrcApiService = LmrcApiService;
        this._logger.debug("CREATED")

        this._queryParamGetter = queryParamGetter;
        this.customEndMessage = "";
        this.hasCustomEndMessage = false;
        this.warning = EmailService.getWarning();
        this.loading = true;
    }

    $onInit() {
        this._logger.debug("INITIALIZING")
        const customizationId = _.trim(this._queryParamGetter('ui', true));
        if (customizationId) {
            const that = this;
            this._lmrcApiService.getCustomization(customizationId)
                .then(resp => {
                    that._logger.debug("getCustomization response", resp.data);
                    if (resp.data.customEndMessage) {
                        that._logger.debug("getCustomization setting customEndMessage", resp.data.customEndMessage);
                        that.customEndMessage = resp.data.customEndMessage;
                        that.hasCustomEndMessage = true;
                        that._logger.debug("DOMAIN CHANGED")
                    }
                    that.loading = false;
                }, err => {
                    that._logger.debug("getCustomization failed, using default conf", err);
                    that.loading = false;
                });

        } else {
            _logger.debug("getCustomization no customization")
            this.loading = false;
        }
        this._logger.debug("INITIALIZED")
    }



}

export default angular.module('lmrcApp.success', [
        uiRouter,

        translateModule,
        feconClientBundle,
        util,
        api
    ])
    .config(routing)
    .component('success', {
        template: require('./success.html'),
        controller: SuccessController
    })
    .name;


// WEBPACK FOOTER //
// ./client/app/features/success/index.js